import React from "react";
import { Box } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";

/**
 * Social Metrics Bars Chart Component using MUI X Charts
 * Displays stacked bar chart for social metrics over time
 * @param {Object} props
 * @param {Object} props.data - Chart data with categories, socialItems, hideMap, colorMap
 * @returns {import("react").ReactElement}
 */
export default function SocialBars(props) {
  const { data } = props;

  if (!data || !data.socialItems || !data.categories) {
    return (
      <Box sx={{ position: "relative" }}>
        <Box sx={{ display: "inline-block", width: 590, height: 300, mb: -2.5 }} />
      </Box>
    );
  }

  const { categories, socialItems, hideMap = {}, colorMap = {} } = data;

  // Filter selected items (exclude hidden items and linkShare)
  const selectedItems = socialItems.filter(
    (item) => !hideMap[item.name] && item.name !== "linkShare",
  );

  if (selectedItems.length === 0 || categories.length === 0) {
    return (
      <Box sx={{ position: "relative" }}>
        <Box sx={{ display: "inline-block", width: 590, height: 300, mb: -2.5 }} />
      </Box>
    );
  }

  // Create series for each social item
  const series = selectedItems.map((item) => ({
    data: item.data.slice(0, categories.length),
    label: item.name,
    color: colorMap[item.name] || item.color || "#03a9f4",
    stack: "social",
    valueFormatter: (value) => value?.toLocaleString() || "0",
  }));

  return (
    <Box sx={{ position: "relative" }}>
      <Box sx={{ display: "inline-block", width: 590, height: 300, mb: -2.5 }}>
        <BarChart
          xAxis={[
            {
              scaleType: "band",
              data: categories,
              tickLabelStyle: {
                fontSize: 10,
              },
            },
          ]}
          yAxis={[
            {
              disableLine: true,
            },
          ]}
          series={series}
          width={590}
          height={300}
          margin={{ top: 20, right: 20, bottom: 40, left: 50 }}
          hideLegend
        />
      </Box>
    </Box>
  );
}
